import * as Loaders from './loaders';
window.Loaders = Loaders;
export { Loaders };
